import flattenRows from '../../webcommon/common/adapters/flattenRows';
import fp from 'lodash/fp';

// mapRows converts the DrilldownAPI response into a format suitable for flattenRows
const mapRows = function mapRows(rows) {
    let id = 0;
    const mapRow = function mapRow(row) {
        const { csaResultDetails, ...newRow } = row;
        id += 1;
        return {
            id: id.toString(),
            ...newRow,
            children: csaResultDetails ? csaResultDetails.map(mapRow) : []
        };
    };
    return rows.map(mapRow);
};

// After flattening, some key values must be removed from different levels
const removeImModel = rows => rows.map(
    row => (row.level > 0 ? fp.unset('imModel', row) : row)
);

const removeSilo = rows => rows.map(
    row => (row.level > 1 ? fp.unset('silo', row) : row)
);

const removeRiskClass = rows => rows.map(
    row => (row.level > 2 ? fp.unset('riskClass', row) : row)
);

const removeSenstivity = rows => rows.map(
    row => (row.level > 3 ? fp.unset('senstivity', row) : row)
);

const setUnexpanded = rows => rows.map(
    row => (row.level === 0 ? fp.set('expanded', false, row) : row)
);

const calculateTotalRow = ((rows) => {
    const simmRow = rows.find(row => row.imModel === 'SIMM');
    const scheduleRow = rows.find(row => row.imModel === 'Schedule');

    const imPledgeEur = (simmRow !== undefined ? simmRow.imPledgeEur : 0)
    + (scheduleRow !== undefined ? scheduleRow.imPledgeEur : 0);

    const imReceiveEur = (simmRow !== undefined ? simmRow.imReceiveEur : 0)
    + (scheduleRow !== undefined ? scheduleRow.imReceiveEur : 0);

    const imPledgeUsd = (simmRow !== undefined ? simmRow.imPledgeUsd : 0)
    + (scheduleRow !== undefined ? scheduleRow.imPledgeUsd : 0);

    const imReceiveUsd = (simmRow !== undefined ? simmRow.imReceiveUsd : 0)
    + (scheduleRow !== undefined ? scheduleRow.imReceiveUsd : 0);

    const trades = (simmRow !== undefined ? simmRow.trades : 0)
    + (scheduleRow !== undefined ? scheduleRow.trades : 0);

    if (simmRow !== undefined || scheduleRow !== undefined) {
        const totalRow = {
            id: (rows.length + 1).toString(),
            parentDetail: null,
            level: 0,
            imModel: 'Total',
            silo: '',
            riskClass: '',
            senstivity: '',
            bucket: '',
            trades,
            imPledgeEur,
            imReceiveEur,
            imPledgeUsd,
            imReceiveUsd,
            children: [],
            childIndex: rows.filter(row => row.level === 0).length,
            expanded: true
        };
        rows.push(totalRow);
    }
    return rows;
});

export default fp.flow(
    mapRows,
    flattenRows,
    setUnexpanded,
    removeImModel,
    removeSilo,
    removeRiskClass,
    removeSenstivity,
    calculateTotalRow
);
